import React, { Component, Fragment } from 'react'
import { inject } from "mobx-react";
import { Label, Col, Row, FormGroup, Form, Input, CustomInput, Button, Alert } from "reactstrap";
import { observer } from "mobx-react";
import ModalForm from '../../comum/components/ModalForm';
import { Baixar, IconeFechar } from '../../comum/components/Icones';
import lscache from 'lscache';

@inject("store")
@observer
export default  class ModalArquivos extends Component {
    
    constructor(props){
        super(props);
        
        this.controller = props.controller;

        this.state = {
            Arquivos: [],
        };
    }

    componentDidMount() {
        this.controller
    }

    fecharModal = () => {
        this.controller.listaAnexosDesova = [];
        this.controller.showModalArquivos = false;
    }
    
    salvarArquivos = () => this.controller.salvarArquivos();

    
    form = () =>{
        const internoExterno = lscache.get('InternoExterno');
        return (
            <FormGroup>
                <Row className={'px-3'}>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Label>Anexos</Label>
                        <Input className="p-2 mb-4" type="file" onChange={e => this.controller.anexarArquivo(e)} accept=".csv, .xml, .txt, .xls, .xlsx, .doc, .pdf" multiple />
                    </Col>
                    {this.controller.listaAnexosDesova && this.controller.listaAnexosDesova.length > 0 &&
                        <Col xs={12} md={12} className="mb-4">{
                            this.controller.listaAnexosDesova.map((item, index) =>
                                <div key={index} className={`item-anexo`}>
                                    <span>{`${item.Nome}.${item.Extensao}`}</span>
                                    <span>
                                        {(internoExterno === 'I' || item.PermiteDownload || item.Id === 0) &&
                                            <Fragment>
                                                <Baixar tamanho="lg" className="mr-2" cor="#001c43" onClick={() => this.controller.baixarAnexo(item.Id, index)} />
                                                <IconeFechar tamanho="lg" onClick={() => this.controller.removerAnexo(item.Id, index)} />
                                            </Fragment>
                                        }
                                    </span>
                                </div>
                            )}
                        </Col>
                    }
                </Row>
            </FormGroup>
        )
    }

    render() {
        return (
            <ModalForm
                className="tamanho-modal-500 modal-analise"
                labelCancelar="CANCELAR"
                onClickSalvar={() => this.salvarArquivos()}
                onClickCancelar={() => this.fecharModal()}
            >
                <h2>Anexos da desova correspondente ao documento</h2>
                <Form>
                    {this.form()}
                </Form>
            </ModalForm>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/acompanhamento/components/ModalArquivos.js